import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { defineComponent as n, h as t } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const r = n({
  props: {
    onFocus: Function,
    onBlur: Function
  },
  setup(o) {
    return () => t("div", {
      style: "width: 0; height: 0",
      tabindex: 0,
      onFocus: o.onFocus,
      onBlur: o.onBlur
    });
  }
});
export {
  r as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/focus-detector/src/FocusDetector.js
// module id = 138
// module chunks = 41